import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import apiRoutes from '@/lib/apiRoutes';
import httpClient from '@/lib/httpClient';
import type {
  Banner,
  DefaultCmsDataResponse,
  DefaultCmsError,
  DefaultCmsResponse,
} from '../types';

export const getHomeBannerFn = async () => {
  const response = await httpClient.get<
    DefaultCmsResponse<DefaultCmsDataResponse<Banner>>
  >(process.env.NEXT_PUBLIC_CMS_API_URI + apiRoutes.cms.homeBanner.list, {
    cmsTokenRequired: true,
  });
  return response.data;
};

export const useGetHomeBanner = (
  opts?: UseQueryOptions<
    DefaultCmsResponse<DefaultCmsDataResponse<Banner>>,
    DefaultCmsError
  >
) =>
  useQuery<DefaultCmsResponse<DefaultCmsDataResponse<Banner>>, DefaultCmsError>(
    [process.env.NEXT_PUBLIC_CMS_API_URI + apiRoutes.cms.homeBanner.list],
    getHomeBannerFn,
    opts
  );
